import React from 'react';
import { Anchor } from 'elements';
import {
  StyledList,
  ListHeading,
} from './styled';

const NoderigiResursi = ({ resursi }) => {
  const renderHeading = (text) => (
    <ListHeading>
      {text}
    </ListHeading>
  );

  const renderLink = (label, url) => (
    <Anchor href={url}>
      {label}
    </Anchor>
  );

  if (resursi && Array.isArray(resursi)) {
    const list = resursi.map(item => {
      const itemLayout = item.acf_fc_layout;

      if (itemLayout === 'grupas_nosaukums') {
        return renderHeading(item.title);

      } else if (itemLayout === 'saite') {
        return renderLink(item.title, item.url);
      }
    });

    return (
      <StyledList>
        {list.map((item, i) => (
          <li key={i}>
            {item}
          </li>
        ))}
      </StyledList>
    );
  }

  return null;
};

export default NoderigiResursi;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/NoderigiResursi/NoderigiResursi.jsx